// Styles for Footer go here.
import styled from 'styled-components';

export const StyledHeroGallery = styled.div`
  .carousel {
    background-color: var(--color-black);
    position: relative;
  }
  .carousel-inner {
    position: relative;
    width: 100%;
    overflow: hidden;
  }

  .carousel-item {
    position: relative;
    display: none;
    float: left;
    width: 100%;
    margin-right: -100%;
    backface-visibility: hidden;
  }

  .carousel-item.active,
  .carousel-item-next,
  .carousel-item-prev {
    display: block;
  }

  .carousel-fade {
    .carousel-item {
      opacity: 0;
      transition-property: opacity;
      transform: none;
    }

    .carousel-item.active,
    .carousel-item-next.carousel-item-start,
    .carousel-item-prev.carousel-item-end {
      z-index: 1;
      opacity: 1;
    }

    .active.carousel-item-start,
    .active.carousel-item-end {
      z-index: 0;
      opacity: 0;
    }
  }

  .carousel::after {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
    top: 0;
    left: 0;
    z-index: 100;
  }
  .carousel .image-hero {
    height: 590px;
    object-fit: cover;
    width: 100%;
  }
  .carousel .content-wrapper {
    position: absolute;
    top: 0;
    z-index: 101;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    padding-right: 1rem;
  }
  .carousel-item {
    transition: transform 3s ease-in-out;
  }
  .carousel-fade .carousel-item.active,
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: opacity 0s 3s;
  }
  .carousel-item .credit-line--mobile {
    display: block;
  }
  .carousel-item .credit-line-wrapper.desktop {
    display: none;
  }
  .carousel-item .credit-line-wrapper {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.5);
    padding: 5px 10px;
    border-radius: 5px;
    bottom: 20px;
  }
  .carousel-item .credit-line-wrapper .credit-line {
    font-size: 12px;
    color: var(--color-white);
    margin: 0;
  }
  .logo-wrapper {
    width: 125px;
    height: 30px;
    margin-bottom: 10px;
  }
  .logo-wrapper img {
    width: 100%;
  }
  .title-wrapper .lt-title-1,
  .copy-wrapper p {
    color: var(--color-white);
  }
  .title-wrapper {
    max-width: 650px;
  }
  .copy-wrapper {
    max-width: 600px;
  }
  @media (min-width: 992px) {
    .carousel::after {
      background-image: linear-gradient(to right, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
    }
    .carousel .image-hero {
      height: 671px;
    }
    .carousel-item .credit-line--mobile {
      display: none;
    }
    .carousel-item .credit-line-wrapper.desktop {
      display: block;
      right: 20px;
      left: unset;
    }
    .logo-wrapper {
      margin-bottom: 20px;
      width: 153px;
      height: 37px;
    }
    .copy-wrapper {
      margin-top: 12px;
    }
  }
`;
